<div class="modal-body">
  <form (ngSubmit)="modal.close(model)">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-secondary" data-dismiss="modal" type="button">
    {{ "Cancel" }}
  </button>

  <button (click)="onSearch($event)" class="btn btn-primary" type="submit">
    {{ "Search" }}
  </button>
</div>
